/**
 * jy-dragon (ดาบมังกรผ่าฟ้า) live: the lamp-hook-sabre set piece (sampleArt/arts/brocade.ts `dragon`) timed to the rules'
 * beats (packages/shared data/longMoves/allUlts.ts, leap template) instead of its own page clock, the way
 * fx/longTempest.ts does bs-tempest: the gather over the tell, the rising cut on the uproot's blow, the dragon on the
 * rise, the wings on the hang, the sky-splitting cut on the first dive's blow, the three wing cuts on the pass's blows,
 * the dragon lashing down on the second dive's blow, the ribbons falling over the kneel. The afterimages come from the
 * beats' `ai` (render/longMove.ts), so the sample's own are left out.
 */
import { longMoveOf } from '@nine/shared';
import { blowTimes, longRetime } from '../longMove';
import { registerFx } from './registry';
import { portOf } from './sampleArt/port';
import { BROCADE_DRAGON_T as T } from './sampleArt/arts/brocade';

registerFx([], (host) => {
  const def = longMoveOf('jy-dragon');
  const spec = portOf('jy-dragon');
  if (!def || !spec) return {};
  const at = (pose: string, from = 0): number => def.beats.findIndex((b, i) => i >= from && b.pose === pose);
  const up = at('tpUproot');
  const rise = at('tpRise');
  const hang = at('tpGather');
  const dive1 = at('tpDive');
  const pass = at('tpPassA', dive1 + 1);
  const dive2 = at('tpDive', pass + 1);
  const kneel = at('tpKneel');
  if ([up, rise, hang, dive1, pass, dive2, kneel].some((i) => i < 0)) return {};
  const passes = blowTimes(def, pass);
  // [piece s, sample s], in order.
  const anchors: [number, number][] = [
    [-def.opener.tell, 0.05],
    [blowTimes(def, up)[0]!, T.up],
    [def.beats[rise]!.at, T.rise],
    [def.beats[hang]!.at, T.hang],
    [blowTimes(def, dive1)[0]!, T.dive],
    [passes[0]!, T.pass[0]],
    [passes[1] ?? passes[0]! + 0.15, T.pass[1]],
    [passes[passes.length - 1]!, T.pass[2]],
    [blowTimes(def, dive2)[0]!, T.fin],
    [def.beats[kneel]!.at, T.kneel],
    [def.len, T.end],
  ];
  spec.on = true;
  spec.ghosts = undefined;
  spec.retime = longRetime(host.world, 'jy-dragon', anchors, T.end);
  return {};
});
